import { render, staticRenderFns } from "./Zhanshi.vue?vue&type=template&id=9fdf5d4c&scoped=true&"
import script from "./Zhanshi.vue?vue&type=script&lang=js&"
export * from "./Zhanshi.vue?vue&type=script&lang=js&"
import style0 from "./Zhanshi.vue?vue&type=style&index=0&id=9fdf5d4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fdf5d4c",
  null
  
)

export default component.exports